import styled from "styled-components";
import Title from "common/Typography/Title";
import React from "react";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { hexToRGB } from "@shared/utils/misc";

interface StatisticCardProps {
  title: string;
  icon: React.JSX.Element;
  value: number | string | React.JSX.Element;
}

const StatisticItem = ({ title, icon, value }: StatisticCardProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <Wrapper>
      <Icon $isMobile={isMobile}>{icon}</Icon>
      <TitlesWrapper $isMobile={isMobile}>
        <Title level={isMobile ? 3 : 2}>{value}</Title>
        <Title level={5} type="secondary">
          {title}
        </Title>
      </TitlesWrapper>
    </Wrapper>
  );
};

export default StatisticItem;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`;
const Icon = styled.div<{ $isMobile: boolean }>`
  font-size: ${(p) => (p.$isMobile ? "18px" : "24px")};
  color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.8)};
  background: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.1)};
  height: ${(p) => (p.$isMobile ? "40px" : "50px")};
  width: ${(p) => (p.$isMobile ? "40px" : "50px")};
  min-width: ${(p) => (p.$isMobile ? "40px" : "50px")};
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 12px;
`;
const TitlesWrapper = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
`;
